import { createSlice } from '@reduxjs/toolkit';
import { initialState, commonReducers } from './fileVersionHistory.slice';

const imdVersionHistorySlice = createSlice({
  name: 'imdVersionHistory',
  initialState,
  reducers: { ...commonReducers },
});

export default imdVersionHistorySlice.reducer;
export const {
  setOpenFileVersionHistory,
  setOpenDeleteVersionConfirmationModal,
  addToFileVersions,
  getNextVersions,
  deletedLastVersion,
} = imdVersionHistorySlice.actions;
